import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'
const SeeIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.105573 11.5528C0.246141 11.2717 0.509967 10.8026 0.894336 10.2075C1.5305 9.22245 2.28113 8.23802 3.14546 7.31606C5.66131 4.63249 8.6202 3 12 3C15.3798 3 18.3387 4.63249 20.8545 7.31606C21.7189 8.23802 22.4695 9.22245 23.1057 10.2075C23.49 10.8026 23.7539 11.2717 23.8944 11.5528C24.0352 11.8343 24.0352 12.1657 23.8944 12.4472C23.7539 12.7283 23.49 13.1974 23.1057 13.7925C22.4695 14.7776 21.7189 15.762 20.8545 16.6839C18.3387 19.3675 15.3798 21 12 21C8.6202 21 5.66131 19.3675 3.14546 16.6839C2.28113 15.762 1.5305 14.7776 0.894336 13.7925C0.509967 13.1974 0.246141 12.7283 0.105573 12.4472C-0.0351909 12.1657 -0.0351909 11.8343 0.105573 11.5528ZM2.57441 12.7075C3.14919 13.5974 3.82825 14.488 4.60454 15.3161C6.77619 17.6325 9.2548 19 12 19C14.7452 19 17.2238 17.6325 19.3955 15.3161C20.1718 14.488 20.8508 13.5974 21.4256 12.7075C21.5887 12.4549 21.7334 12.2176 21.8593 12C21.7334 11.7824 21.5887 11.5451 21.4256 11.2925C20.8508 10.4026 20.1718 9.51198 19.3955 8.68394C17.2238 6.36751 14.7452 5 12 5C9.2548 5 6.77619 6.36751 4.60454 8.68394C3.82825 9.51198 3.14919 10.4026 2.57441 11.2925C2.41128 11.5451 2.26659 11.7824 2.14071 12C2.26659 12.2176 2.41128 12.4549 2.57441 12.7075Z"
                fill="currentColor"
            />
        </Icon>
    )
}

SeeIcon.propTypes = {
    secondaryColor: PropTypes.string,
}

export default SeeIcon
